const origin = `${document.location.protocol}//${document.location.hostname}`;
export { origin };
